import Image from "next/image";
import Head from "next/head";
import styles from "../our-faculty/faculty-list.module.css";
import bhaskar from "../../assets/images/faculty/tnpsc-faculty/bhaskar.webp";
import sivabalanu from "../../assets/images/faculty/tnpsc-faculty/sivabalan-u.webp";
import karthikeyanp from "../../assets/images/faculty/tnpsc-faculty/karthikeyan-p.webp";
import sumathir from "../../assets/images/faculty/tnpsc-faculty/sumathi-r.webp";
import kanchana from "../../assets/images/faculty/tnpsc-faculty/kanchana.webp";
import manikandan from "../../assets/images/faculty/tnpsc-faculty/manikandan.webp";
import moorthy from "../../assets/images/faculty/tnpsc-faculty/moorthy.webp";
import dineshprasath from "../../assets/images/faculty/tnpsc-faculty/dinesh-prasath.webp";
import udaiappan from "../../assets/images/faculty/tnpsc-faculty/udaiappan.webp";
import tharani from "../../assets/images/faculty/tnpsc-faculty/tharani.webp";
import yasodha from "../../assets/images/faculty/tnpsc-faculty/yasodha.webp";
import selvashankar from "../../assets/images/faculty/tnpsc-faculty/selvashankar.webp";
import srinivasan from "../../assets/images/faculty/tnpsc-faculty/srinivasan.webp";
import sucharithan1 from "../../assets/images/faculty/tnpsc-faculty/sucharithan.webp";
import bavitram from "../../assets/images/faculty/tnpsc-faculty/bavitram.webp";
import leelakumari from "../../assets/images/faculty/tnpsc-faculty/leela-kumari.webp";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";

const Faculty = () => {
 
  return (
    <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Shankar IAS Academy Faculty List | Online Best UPSC TNPSC</title>
            <meta name="title" content="Shankar IAS Academy Faculty List | Online Best UPSC TNPSC" />
            <meta name="description" content="Shankar IAS Academy Faculty List | Best List of Faculties for UPSC, TNPSC, Optional, General Studies & Test Series. Our List of Faculties are the Best" />
            <link rel="canonical" href="https://www.shankariasacademy.com/our-faculty/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Shankar IAS Academy Faculty List | Online Best UPSC TNPSC" />
            <meta property="og:description" content="Shankar IAS Academy Faculty List | Best List of Faculties for UPSC, TNPSC, Optional, General Studies & Test Series. Our List of Faculties are the Best" />
            <meta property="og:url" content="https://www.shankariasacademy.com/our-faculty/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>
    
      <Navbar title="about" />

     
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>Our Faculty Team</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}
            >
              <Link href="/our-faculty">
                <button
                  id={styles.tablinks}
                  className="nav-link tab1 py-2 px-0 me-4"
                  type="button"
                >
                  UPSC Faculties
                </button>
              </Link>

            {/*  <Link href="/visiting-faculty-panel-members">
                <button
                  id={styles.tablinks}
                  className="nav-link tab2 py-2 px-0 me-4"
                  type="button"
                >
                  UPSC - Visiting UPSC Faculties
                </button>
  </Link> */}

              <Link href="/tnpsc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  type="button"
                >
                  TNPSC Faculties
                </button>
              </Link>
              <Link href="/bankingssc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  type="button"
                >
                  Banking & SSC Faculties
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={bhaskar}
                      alt="Mr.Bhaskar Kumar RM"
                      className="img-fluid"
                      title="Mr.Bhaskar Kumar RM"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Bhaskar Kumar RM
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Head - Administration
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={sivabalanu}
                      alt="Mr.Sivabalan U"
                      className="img-fluid"
                      title="Mr.Sivabalan U"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Sivabalan U
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Physics</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={karthikeyanp}
                      alt="Mr.Karthikeyan P"
                      className="img-fluid"
                      title="Mr.Karthikeyan P"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Karthikeyan P
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>History</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={sumathir}
                      alt="Mrs.Sumathi R"
                      className="img-fluid"
                      title="Mrs.Sumathi R"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs.Sumathi R
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Geography
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={kanchana}
                      alt="Mrs.Kanchana"
                      className="img-fluid"
                      title="Mrs.Kanchana"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs.Kanchana
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>English</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={manikandan}
                      alt="Mr. Manikandan"
                      className="img-fluid"
                      title="Mr. Manikandan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Manikandan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Economics
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={moorthy}
                      alt="Mr.Moorthy"
                      className="img-fluid"
                      title="Mr.Moorthy"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Moorthy
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Tamil</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={dineshprasath}
                      alt="Mr.Dinesh Prasath"
                      className="img-fluid"
                      title="Mr.Dinesh Prasath"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Dinesh Prasath
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Mental Ability
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={udaiappan}
                      alt="Mr.Udaiappan"
                      className="img-fluid"
                      title="Mr.Udaiappan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Udaiappan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Chemistry
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={tharani}
                      alt="Ms.Tharani"
                      className="img-fluid"
                      title="Ms.Tharani"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms.Tharani
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Zoology</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={yasodha}
                      alt="Ms.Yasodha"
                      className="img-fluid"
                      title="Ms.Yasodha"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms.Yasodha
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Botany</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={selvashankar}
                      alt="Mr.Selvashankar"
                      className="img-fluid"
                      title="Mr.Selvashankar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Selvashankar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Polity</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={srinivasan}
                      alt="Mr.Srinivasan"
                      className="img-fluid"
                      title="Mr.Srinivasan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Srinivasan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Current Affairs & Polity
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={sucharithan1}
                      alt="Mr.Sucharithan"
                      className="img-fluid"
                      title="Mr.Sucharithan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Sucharithan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>Physics</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={bavitram}
                      alt="Mrs.Bavitram"
                      className="img-fluid"
                      title="Mrs.Bavitram"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs.Bavitram
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>English</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={leelakumari}
                      alt="Ms.Leela Kumari"
                      className="img-fluid"
                      title="Ms.Leela Kumari"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms.Leela Kumari
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>History</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <Footer />
    </>
  );
};

export default Faculty;
